/**
 * ขนาด layout ของ Desktop shell — ตรงกับ visual baseline ใน
 * `ERP UI mockups/ERP Mockups.dc.html`
 *
 * ค่าเหล่านี้ถูกใช้เป็น inline style เพื่อให้ automated test ยืนยันได้จริง
 * (jsdom ไม่ประมวลผล stylesheet ที่ import เข้ามา)
 */

export const SIDEBAR_WIDTH_EXPANDED_PX = 228;
export const SIDEBAR_WIDTH_COLLAPSED_PX = 56;
export const HEADER_HEIGHT_PX = 52;

export function sidebarWidth(expanded: boolean): string {
  return `${expanded ? SIDEBAR_WIDTH_EXPANDED_PX : SIDEBAR_WIDTH_COLLAPSED_PX}px`;
}
